import admin from '../middleware/admin';
import auth from '../middleware/auth';

export default {
    path: 'uznemumi/:companyId',
    name: 'view-company',
    meta: {
        middleware: [auth, admin],
    },
    component: () => import('@/views/site/Company'),
}